// extracted by mini-css-extract-plugin
export default {"root":"root--aUgVe","content":"content--vtI05","caption":"caption--v5qq5","description":"description--r35Q3","action":"action--pGIrP","icon":"icon--w5jc6"};